import { observer } from 'mobx-react';
import { FC } from 'react';
import { Route } from 'react-router-dom';
import OrdersRatingScreen from '../OrdersRatingScreen';
import CustomersProfilesScreen from './screens/CustomersProfilesScreen/CustomersProfilesScreen';
import CrmRestrictionsScreen from './screens/CrmRestrictionsScreen/CrmRestrictionsScreen';
import { SCREENS } from 'src/constants/screens';
import ScreenHeader from '~/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { localeStore } from '~/mobx/localesStore';

const CrmScreen: FC = observer((): JSX.Element => {
  return (
    <div className="d-flex flex-column full-width">
      <ScreenHeader
        title="CRM"
        options={[
          { path: SCREENS.CRM_PROFILES(), title: localeStore.t('crm_customer_accounts_tab_hdr') },
          { path: SCREENS.ORDERS_RATING(), title: localeStore.t('crm_order_rating_report_tab_hdr') },
          { path: SCREENS.CRM_RESTRICTIONS(), title: localeStore.t('crm_restrictions_tab_hdr') },
        ]}
      />
      <>
        <Route exact path={SCREENS.CRM_PROFILES()} component={CustomersProfilesScreen} />
        <Route exact path={SCREENS.ORDERS_RATING()} component={OrdersRatingScreen} />
        <Route exact path={SCREENS.CRM_RESTRICTIONS()} component={CrmRestrictionsScreen} />
      </>
    </div>
  );
});

export default CrmScreen;
